var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.haveItems)?_c('ul',{class:[
    'list',
    { [`list--${_vm.variant}`]: !!_vm.variant },
    { [`list--${_vm.size}`]: !!_vm.size },
    { [`list--icon-${_vm.icon}`]: !!_vm.icon },
  ]},_vm._l((_vm.items),function(item,index){return _c('li',{key:index,staticClass:"list__item"},[_vm._t("default",function(){return [_c('span',{domProps:{"innerHTML":_vm._s(item)}})]},{"listItem":item})],2)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }